module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isImg) ? _c('div', {
    staticClass: "img-file-wapper"
  }, [_c('div', {
    staticClass: "fx file-n-wapper"
  }, [_c('div', {
    staticClass: "file-n-cont"
  }, [_c('ul', {
    staticClass: "fx fx-wrap"
  }, _vm._l((_vm.listArr), function(item, index) {
    return _c('li', [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pic-delete fx-align",
      on: {
        "click": function($event) {
          return _vm.handleDelFile(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-del"
    })])])
  }), 0)]), _vm._v(" "), (_vm.fileNum != _vm.listArr.length) ? _c('div', {
    staticClass: "up-n-btn"
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleFile
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()])]) : _c('div', {
    staticClass: "words-file-wapper"
  }, [_c('div', {
    staticClass: "file-n-wapper"
  }, [_c('div', {
    staticClass: "file-n-cont"
  }, [_c('ul', _vm._l((_vm.listArr), function(item, index) {
    return _c('li', {
      staticClass: "fx"
    }, [_c('p', [_vm._v(_vm._s(_vm._f("urlFilter")(item)))]), _vm._v(" "), _c('div', {
      staticClass: "file-delete m-l-5 fx-align",
      on: {
        "click": function($event) {
          return _vm.handleDelFile(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-del"
    })])])
  }), 0)]), _vm._v(" "), (_vm.fileNum != _vm.listArr.length) ? _c('div', {
    staticClass: "up-n-btn b-r-3"
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleFile
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3"
  }, [_vm._v("上传\t")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', {
    staticClass: "icon-add file-add"
  }), _vm._v(" "), _c('span', {
    staticClass: "up-words"
  }, [_vm._v("上传图片")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-40c5704f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/UpFile.vue
// module id = 834
// module chunks = 0